export default "__VITE_ASSET__12f8df44__"